import Vue from "vue";
import "./assets/css/app.scss";
import store from "./store";
import i18n from "./lang";
import router from "./router";
import VueRouter from "vue-router";
Vue.config.productionTip = false;

// ------ plugins register ------
// import "./mock";
import "./plugins/elementUI";
import "./plugins/fontawesome";
import "./plugins/portal";

import Vue2TouchEvents from "vue2-touch-events";
Vue.use(Vue2TouchEvents, {
  touchHoldTolerance: 10,
  swipeTolerance: 10,
});

require("./assets/js/datePicker.js");
import "./assets/css/vendor/datePicker.css";
import "./mixins";

// ------ directive -----
import "./directives";

Vue.filter("MoreThenTen", function (value) {
  if (parseInt(value) > 9) {
    return "9+";
  }
  return value;
});

// ------ components register ------
import TgTable from "@/components/table/TgTable";
Vue.component("tg-table", TgTable);

// ------ other ------
store.dispatch("app/fetchLangList");
store.dispatch("service/fetch");
store.dispatch("thirdParty/fetch");

// let __origin_title = document.title ?? '';

router.afterEach((to) => {
  let then = () => {
    let title_key = to.meta.langKey;

    if (!title_key) {
      title_key = to.meta.parent ? "menu." + to.meta.parent.name : "";
    }

    let site_title = window.__site_title
      ? window.__site_title
      : i18n.t("component.header.title" + (window.__is_admin ? ".games" : ""));
    let prefix = store.getters["app/siteTitle"]
      ? store.getters["app/siteTitle"] + " - "
      : "";

    document.title =
      prefix + site_title + (title_key ? " - " + i18n.t(title_key) : "");
  };
  then();
});

router.afterEach(async (to, from, next) => {
  // 確保每次往下傳遞頁面時都能檢查語言包狀態
  let goNext = (t) => {
    return next ? next(t) : null;
  };
  if (to.meta && to.meta.auth == false) {
    return goNext();
  }
  // 檢查登入訊息，並動態註冊routes
  // 尚未取得使用者資訊

  if (!store.getters["app/logined"]) {
    await store.dispatch("app/fetchLang").then(() => {
      store.dispatch("app/fetch").then((response) => {
        let { menu, user } = response.data;
        store.dispatch("generateRoutes", { user, menu, i18n }).then(() => {
          const routes = store.getters.routes;
          routes.forEach((route) => {
            try {
              // 嘗試解析路由，如果不存在會拋出錯誤
              const existingRoute = router.resolve(route);
              if (!existingRoute.route.matched.length) {
                router.addRoute(route);
              }
            } catch (error) {
              // 路由不存在，添加它
              router.addRoute(route);
            }
          });
          // 登入成功導向，此時的next物件尚不認識新的路由表
          // 故要透過push重發導向請求
          if (from.name == "login") {
            router.push(to);
          } else {
            goNext({ ...to, replace: true });
          }
        });
      });
    });
  } else {
    // historyKey reset
    if (to.redirectedFrom) {
      goNext({ name: to.name, replace: true });
    } else if (to.name === "service" && store.getters["service/onlyService"]) {
      store.dispatch("service/showService", store.state.app.user);
      goNext(from);
    } else {
      goNext();
    }
  }
});

// 全域處理路由重複導航錯誤
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => {
    // 處理所有導航相關錯誤
    if (
      err.name !== "NavigationDuplicated" &&
      !err.message.includes("Navigation cancelled") &&
      !err.message.includes("Avoided redundant navigation")
    ) {
      throw err;
    }
  });
};

VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch((err) => {
    if (
      err.name !== "NavigationDuplicated" &&
      !err.message.includes("Navigation cancelled") &&
      !err.message.includes("Avoided redundant navigation")
    ) {
      throw err;
    }
  });
};
